const TOKEN_KEY = 'auth_token';

// --- Token CRUD ---

export function getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
}

// --- Logout Bridge ---
// Permet au ErrorLink Apollo (hors React) de notifier le AuthContext (React)
// qu'un logout doit se produire.

type LogoutCallback = () => void;

let onLogoutCallback: LogoutCallback | null = null;

export function registerLogoutCallback(cb: LogoutCallback): void {
    onLogoutCallback = cb;
}

export function triggerLogout(): void {
    removeToken();
    onLogoutCallback?.();
}
